// extracted by mini-css-extract-plugin
module.exports = {"container":"e_qyb","selected":"e_ryb","variantLike":"e_syb","icon":"e_tyb","variantDislike":"e_uyb","disabled":"e_vyb"};